import type { Project } from "../hooks/useProjects.ts";
import { ProjectCard } from "./ProjectCard.tsx";

export function ProjectGrid({ projects, startRank = 1 }: { projects: Project[]; startRank?: number }) {
  if (projects.length === 0) {
    return (
      <div className="text-center py-16 text-text-muted text-xs">
        no projects found
      </div>
    );
  }

  return (
    <div className="border-t border-border">
      {/* Table header */}
      <div className="flex items-center gap-4 px-4 py-2 text-[10px] uppercase tracking-widest text-text-muted border-b border-border">
        <span className="w-6 text-right shrink-0">#</span>
        <span className="w-6 shrink-0"></span>
        <span className="flex-1">Project</span>
        <div className="flex items-center gap-4 shrink-0">
          <span className="hidden sm:inline w-16">Lang</span>
          <span className="w-16 text-right">Stars</span>
          <span className="w-14 text-right hidden sm:inline">Forks</span>
          <span className="w-16 text-right hidden md:inline">Committed</span>
        </div>
      </div>
      {projects.map((p, i) => (
        <ProjectCard key={p.id} project={p} rank={startRank + i} />
      ))}
    </div>
  );
}
